import { useRFSLogs } from "@/api/rfs";
import { MISSING_ID_IN_ROUTE } from "@/utils/constant";
import { useParams } from "react-router-dom";
import { formatDateTime } from "@/utils/helper/formatDate";

export function LogHistoryPanel() {
  const { id } = useParams();

  if (!id) {
    throw new Error(MISSING_ID_IN_ROUTE);
  }

  const { data: logs } = useRFSLogs({ id });

  return (
    <div className="overflow-x-auto">
      <table className="w-full table-auto border-collapse">
        <thead>
          <tr>
            <th className="p-4 text-left text-sm font-medium">Created Date</th>
            <th className="p-4 text-left text-sm font-medium">Username</th>
            <th className="p-4 text-left text-sm font-medium">Cluster ID</th>
            <th className="p-4 text-left text-sm font-medium">Request ID</th>
            <th className="p-4 text-left text-sm font-medium">Status Before</th>
            <th className="p-4 text-left text-sm font-medium">Status After</th>
            <th className="p-4 text-left text-sm font-medium">
              Total Homepass
            </th>
            <th className="p-4 text-left text-sm font-medium">Notes</th>
          </tr>
        </thead>
        <tbody>
          {logs?.map((log) => (
            <tr key={log.id} className="border-y">
              <td className="p-4 text-left text-sm">
                {formatDateTime(log.createdDate) ?? "-"}
              </td>
              <td className="p-4 text-left text-sm">{log.actByName ?? "-"}</td>
              <td className="p-4 text-left text-sm">{log.clusterId ?? "-"}</td>
              <td className="p-4 text-left text-sm">{log.requestId ?? "-"}</td>
              <td className="p-4 text-left text-sm">
                {log.statusBefore || "-"}
              </td>
              <td className="p-4 text-left text-sm">
                {log.statusAfter || "-"}
              </td>
              <td className="p-4 text-left text-sm">{log.totalHpRfs ?? "-"}</td>
              <td className="p-4 text-left text-sm">{log.remarks ?? "-"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
